import React from 'react';
import BatteryDischargeEstimatorTooltip from '@di-shared/features/diag/battery/discharge/BatteryDischargeEstimatorTooltip';
import useBatteryStatus, {ExpectedDischargeDaysGauge} from '@di-shared/features/diag/battery/useBatteryStatus';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

interface BatteryDischargeEstimatorProps {
  vin: string;
}

function BatteryDischargeEstimator({vin}: BatteryDischargeEstimatorProps) {
  const {t} = useInferableTranslation();
  const {expectedDischargeDaysGauge} = useBatteryStatus(vin);
  return (
    <div className="section_container">
      <div className="section_container_header">
        <h3 className="title_xxsmall">{t('T30361')}</h3>
        <BatteryDischargeEstimatorTooltip />
      </div>
      <div
        className={`discharge_estimate ${expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge6 ? 'type_good' : expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge1 ? 'type_warning' : 'type_caution'}`}
      >
        <span
          className="discharge_estimate_item"
          aria-current={expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge1}
        >
          {t('T20085')}
        </span>
        <span
          className="discharge_estimate_item"
          aria-current={expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge2}
        >
          {t('T30082_$days_#short', {days: '1~2'})}
        </span>
        <span
          className="discharge_estimate_item"
          aria-current={expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge3}
        >
          {t('T30082_$days_#short', {days: '2~3'})}
        </span>
        <span
          className="discharge_estimate_item"
          aria-current={expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge4}
        >
          {t('T30082_$days_#short', {days: '3~4'})}
        </span>
        <span
          className="discharge_estimate_item"
          aria-current={expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge5}
        >
          {t('T30082_$days_#short', {days: '4~5'})}
        </span>
        <span
          className="discharge_estimate_item"
          aria-current={expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge6}
        >
          {t('T30081_$days', {days: 5})}
        </span>
      </div>
      <div className="divider"></div>
      {expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge6 && (
        <>
          <strong className="discharge_estimate_title">{t('T30083')}</strong>
          <p
            className="discharge_estimate_desc"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T30084')}
          </p>
        </>
      )}
      {expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge5 && (
        <>
          <strong className="discharge_estimate_title">{t('T30085_$days', {days: '4~5'})}</strong>
          <p className="discharge_estimate_desc">{t('T30086')}</p>
        </>
      )}
      {expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge4 && (
        <>
          <strong className="discharge_estimate_title">{t('T30085_$days', {days: '3~4'})}</strong>
          <p className="discharge_estimate_desc">{t('T30086')}</p>
        </>
      )}
      {expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge3 && (
        <>
          <strong className="discharge_estimate_title">{t('T30085_$days', {days: '2~3'})}</strong>
          <p className="discharge_estimate_desc">{t('T30086')}</p>
        </>
      )}
      {expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge2 && (
        <>
          <strong className="discharge_estimate_title">{t('T30085_$days', {days: '1~2'})}</strong>
          <p className="discharge_estimate_desc">{t('T30086')}</p>
        </>
      )}
      {expectedDischargeDaysGauge === ExpectedDischargeDaysGauge.Gauge1 && (
        <>
          <strong className="discharge_estimate_title">{t('T30087')}</strong>
          <p className="discharge_estimate_desc">{t('T30086')}</p>
        </>
      )}
    </div>
  );
}

export default BatteryDischargeEstimator;
